// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Box, Typography } from '@mui/material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';

// export const CalenderEvents = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const columns = [
//      { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'eventName', field: 'eventName', headerName: 'Event Name', width: 100 },
//     // { id: 'eventDate', field: 'eventDate', headerName: '', width: 100 },
//     { id: 'startDate', field: 'startDate', headerName: 'Start Time', width: 100 },
//     { id: 'endDate', field: 'endDate', headerName: 'End Time', width: 100 },
//     {
//       id: 'detailsLink',
//       field: 'detailsLink',
//       headerName: 'Details',
//       width: 120,
//       renderCell: (params) => (
//         <a href={params.value} target="_blank" rel="noopener noreferrer">
//           View Details
//         </a>
//       ),
//     },
//   ];

//   useEffect(() => {
//     axios.get(`${API_BASE_URL}/home-notification/calender-event/`)
//       .then(response => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id,
//           slNo: index + 1,
//           eventName: item.event_name,
//           // eventDate: item.date_of_event,
//           startDate: new Date(item.start_date).toLocaleDateString('en-GB').replace(/\//g, '-'),
//           endDate: new Date(item.end_date).toLocaleDateString('en-GB').replace(/\//g, '-'),
//           // location: item.location,
//           // organizer: item.organizer,
//           detailsLink: item.link,
//         }));
//         setRows(apiData);
//         setSnackbarMessage('Calendar Events loaded successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         setLoading(false);
//       })
//       .catch(error => {
//         console.error('Failed to fetch calendar events:', error);
//         setSnackbarMessage('Failed to load calendar events.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   }, []);

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   if (loading) {
//     return <LoadingSpinner size={30}/>;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
//         <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
//           Calendar Events
//         </Typography>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus={true}
//         enableSort={true}
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };



import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import { useTranslation } from 'react-i18next';

export const CalenderEvents = () => {
  const { t } = useTranslation();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: t('calenderEvents.slNo'), width: 70 },
    { id: 'eventName', field: 'eventName', headerName: t('calenderEvents.eventName'), width: 100 },
    { id: 'startDate', field: 'startDate', headerName: t('calenderEvents.startTime'), width: 100 },
    { id: 'endDate', field: 'endDate', headerName: t('calenderEvents.endTime'), width: 100 },
    {
      id: 'detailsLink',
      field: 'detailsLink',
      headerName: t('calenderEvents.details'),
      width: 120,
      renderCell: (params) => (
        <a href={params.value} target="_blank" rel="noopener noreferrer">
          {t('calenderEvents.viewDetails')}
        </a>
      ),
    },
  ];

  useEffect(() => {
    axios.get(`${API_BASE_URL}/home-notification/calender-event/`)
      .then(response => {
        const apiData = response.data.map((item, index) => ({
          id: item.id,
          slNo: index + 1,
          eventName: item.event_name,
          startDate: new Date(item.start_date).toLocaleDateString('en-GB').replace(/\//g, '-'),
          endDate: new Date(item.end_date).toLocaleDateString('en-GB').replace(/\//g, '-'),
          detailsLink: item.link,
        }));
        setRows(apiData);
        setSnackbarMessage(t('calenderEvents.successMessage'));
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch(error => {
        console.error('Failed to fetch calendar events:', error);
        setSnackbarMessage(t('calenderEvents.errorMessage'));
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, [t]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          {t('calenderEvents.heading')}
        </Typography>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort={true}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
